// Wishlist feature constants and selectors
const IS_CUSTOMER_LOGGED_IN = Theme.customer?.isLoggedIn;
const CUSTOMER_ID = Theme.customer?.id;

export const CONSTANTS = {
  LOCAL_STORAGE_WISHLIST_KEY: 'wishlist', // Key for storing wishlist in localStorage
  LOCAL_STORAGE_DELIMITER: ',', // Delimiter for wishlist string
  BUTTON_ACTIVE_CLASS: 'active', // CSS class for active wishlist button
  CUSTOMER_LOGGED_IN: IS_CUSTOMER_LOGGED_IN,
  CUSTOMER_ID: CUSTOMER_ID,
  ALL_WISHLIST_URL: CUSTOMER_ID ? `http://netlify.blacklemon.dk/.netlify/functions/getCustomerWishlistProducts?store=rezetstore&customerId=${CUSTOMER_ID}` : '',
  UPDATE_WISHLIST_URL: CUSTOMER_ID ? `http://netlify.blacklemon.dk/.netlify/functions/updateCustomerWishlist?store=rezetstore&customerId=${CUSTOMER_ID}` : '',
};

export const SELECTORS = {
  WISHLIST_SECTION: '.section-main-wishlist',
  WISHLIST_EMPTY: '.wishlist__empty',
  WISHLIST_GRID: '.wishlist__grid',
  WISHLIST_GRID_WRAPPER: '.wishlist__grid--wrapper',
};
